import React, { useRef } from "react";
import { useEffect, useState } from "react";
// import "./investmentDetial.scss";
import Sidebar from "../../Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader/Loader";
import noImg from "../../../../assets/noImage.jpeg";
import { toast } from "react-toastify";
import OPPCss from "../../../Dashboard/Opportunities/Opportunities.module.scss";

function MemberListDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const investment_id = location?.state?.member;

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const [facilityDetails, setFacilityDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingBookings, setLoadingBookings] = useState(true);
  const [bookingData, setBookingData] = useState({});

  const fetchfacilityDetails = async () => {
    setLoading(true);
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/membership/user/${investment_id}/details`;
    const accessToken = window.localStorage.getItem("access_token");

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (response.status === 200) {
        setFacilityDetails(data);
        setShowUserInfo(true); // Show user info when details are fetched
      } else {
        toast.error(data.detail || "Failed to fetch details.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  async function getUserBookings() {
    try {
      const accessToken = window.localStorage.getItem("access_token");
      setShowUserInfo(false); // Hide user info when bookings are fetched
      setLoadingBookings(true); // Show loader while fetching bookings
      const response = await fetch(
        `https://ballersapi.ballerslife.co/api/v1/admin/membership/user/${investment_id}/bookings`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (response.status === 200) {
        setBookingData(data);
      }
    } catch (error) {
      console.error("Error fetching user bookings:", error);
      setBookingData(null);
    } finally {
      setLoadingBookings(false); // Hide loader after fetching bookings
    }
  }

  const [showUserInfo, setShowUserInfo] = useState(true);

  const inputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [uploadBtn, setUploadBtn] = useState(false);
  const [imgPreview, setImgPreview] = useState(false);
  const uploadImage = () => {
    inputRef.current.click();
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setUploadBtn(true);
    setImgPreview(true);
  };

  useEffect(() => {
    fetchfacilityDetails();
  }, []);

  const formatNumber = (num) => {
    let formattedNumber;
    if (num >= 1000000000) {
      formattedNumber = (num / 1000000000).toFixed(1) + "B";
    } else if (num >= 1000000) {
      formattedNumber = (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      formattedNumber = (num / 1000).toFixed(1) + "K";
    } else {
      return num?.toString();
    }
    if (
      formattedNumber.endsWith(".0K") ||
      formattedNumber.endsWith(".0M") ||
      formattedNumber.endsWith(".0B")
    ) {
      formattedNumber =
        formattedNumber.slice(0, -3) + formattedNumber.slice(-1);
    }

    return formattedNumber;
  };

  const [sendMail, setSendMail] = useState(false);
  const handleSendMail = () => {
    setSendMail(!sendMail);
  };
  const formatClubTimings = (timings) => {
    if (!timings) return "Not available";

    // Convert the timings object into a formatted string
    return Object.entries(timings)
      .map(([days, { start_time, close_time }]) => {
        return `${days}: ${start_time} - ${close_time}`;
      })
      .join("<br />");
  };
  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        <div>
          <div className="goBackSvg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#FFBF00"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-left"
              onClick={() => {
                navigate(-1);
              }}
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
          </div>
          <div className="fetchUserWrap">
            <div
              className="fetchUserInfoBtn"
              onClick={() => {
                fetchfacilityDetails();
              }}
            >
              <div className="userBtnOPt">
                <p htmlFor="location-select">User Details</p>
              </div>
            </div>
            <div
              className="fetchUserInfoBtn"
              onClick={() => {
                getUserBookings();
              }}
            >
              <div className="userBtnOPt">
                <p htmlFor="location-select">Bookings</p>
              </div>
            </div>
          </div>
          {showUserInfo ? (
            <>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="logoBtnMain">
                    <div className="clubLogoMain">
                      <>
                        {facilityDetails?.member_profile_pic_url == null ? (
                          <img src={noImg} alt="" className="clubLogo" />
                        ) : (
                          <img
                            src={facilityDetails?.member_profile_pic_url}
                            alt=""
                            className="clubLogo"
                          />
                        )}
                      </>
                      <input
                        type="file"
                        ref={inputRef}
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                      />
                    </div>
                  </div>
                  <div className="invOverviewMain">
                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">MEMBER NAME :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html:
                            facilityDetails?.user_details?.member_name || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">EMAIL ID :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html:
                            facilityDetails?.user_details?.email_id || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">PHONE NO :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: `${
                            facilityDetails?.user_details?.country_code || ""
                          } ${
                            facilityDetails?.user_details?.phone_no || "N/A"
                          }`,
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">CITY :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: facilityDetails?.user_details?.city || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">COUNTRY :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html:
                            facilityDetails?.user_details?.country || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">DOB :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: facilityDetails?.user_details?.DOB || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">WORK PROFILE :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html:
                            facilityDetails?.user_details
                              ?.member_work_profile || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">PAYMENT STATUS :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html:
                            facilityDetails?.user_details?.payment_status ||
                            "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">
                        INTERESTED SPORTS :
                      </p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html:
                            facilityDetails?.user_details?.interested_sports?.join(
                              ", "
                            ) || "N/A",
                        }}
                      />
                    </div>

                    <div className="invOverviewCont">
                      <p className="invOverviewContFirst">MEMBER SINCE :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: facilityDetails?.user_details?.created_at
                            ? new Date(
                                facilityDetails.user_details.created_at
                              ).toLocaleDateString()
                            : "N/A",
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              {loadingBookings ? (
                <Loader />
              ) : (
                <>
                  {bookingData == null ? (
                    <div className={OPPCss.fcAllBookingMain}>
                      No bookings available.
                    </div>
                  ) : (
                    <>
                      <div className={OPPCss.fcAllBookingMain}>
                        <div className={OPPCss.fcAllBookingHeader}>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">CITY</p>
                          </div>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">FACILITY NAME</p>
                          </div>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">DATE</p>
                          </div>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">BOOKING TIME</p>
                          </div>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">PLAYERS REQ</p>
                          </div>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">COURTS</p>
                          </div>
                          <div className={OPPCss.fcAllBookingCell}>
                            <p className="investmentHeader">STATUS</p>
                          </div>
                        </div>
                        {bookingData?.bookings?.map((booking, index) => (
                          <div
                            className={OPPCss.fcAllBookingRow}
                            key={booking.booking_id}
                          >
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.city}</p>
                            </div>
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.facility_name}</p>
                            </div>
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.booking_date}</p>
                            </div>
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.booking_time}</p>
                            </div>
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.players_req}</p>
                            </div>
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.courts_req}</p>
                            </div>
                            <div className={OPPCss.fcAllBookingCell}>
                              <p>{booking.status}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemberListDetails;
